import _ from 'lodash';
import React, { useState } from 'react';
import { object, string } from 'yup';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';

import { useHttpStatus } from '~/commons/hooks';
import env from '~/commons/config/env';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ModalConfirmLogin from './ModalConfirmLogin.jsx';

const schema = object().shape({
  username: string().trim().lowercase().required('必填'),
  password: string().required('必填'),
});
const defaults = {
  username: '',
  password: '',
};

const FormThemeReportsLogin = () => {
  const [role, setRole] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const [loginRes, loginReq] = useHttpStatus({
    onSuccess({ data }) {
      if (data.allowed !== undefined) {
        setConfirmModal(true);
      } else {
        window.location.replace('enterthematic/management');
      }
    },
  });

  const login = (values) => loginReq({
    method: 'post',
    url: 'api/core/auth',
    data: {
      ...values,
      web: 1,
      role,
      base: window.location.pathname,
    },
  });

  return (
    <>
      {_.isEmpty(role) && (
        <div className="d-flex flex-column">
          <button
            className="btn btn-primary mb-3"
            onClick={() => setRole('teacher')}
          >
            教師登入
          </button>
          <button
            className="btn btn-warning"
            onClick={() => window.location.replace('enterthematic/details')}
          >
            學生進入
          </button>
        </div>
      )}
      {!_.isEmpty(role) && role === 'teacher' && (
        <>
          <div className="row mb-3 align-items-center">
            <div className="col-auto">
              <button className="btn btn-link p-0" onClick={() => setRole('')}>
                <FA icon={faArrowLeft} /> 返回
              </button>
            </div>
            <div className="col text-center">
              <h5 className="mb-0">
                {role === 'student' ? '學生進入' : '教師登入'}
              </h5>
            </div>
            <div className="col-auto"></div>
          </div>
          <Formik
            validationSchema={schema}
            initialValues={defaults}
            onSubmit={(values) => login(values)}
          >
            <Form>
              <ModalConfirmLogin
                show={confirmModal}
                onHide={() => setConfirmModal(false)}
                allow={loginRes?.payload}
              />
              <FormHttpAlert res={loginRes} />
              <FormGroup name="username" label={null} placeholder="帳戶" />
              <FormGroup
                name="password"
                type={showPwd ? 'text' : 'password'}
                label={null}
                placeholder="密碼"
                append={
                  <button
                    type="button"
                    className="btn pwd-visibility"
                    onClick={() => setShowPwd(!showPwd)}
                  >
                    <FA icon={showPwd ? faEyeSlash : faEye} />
                  </button>
                }
              />
              <div className="form-group text-right">
                <FormHttpBtn
                  res={loginRes}
                  type="submit"
                  className="btn-primary btn-block"
                  icon={faDoorOpen}
                >
                  登入
                </FormHttpBtn>
              </div>
            </Form>
          </Formik>
        </>
      )}
    </>
  );
};

export default FormThemeReportsLogin;
